const pType = {
  "Single Bag": 1,
  "Box of 200 Bags": 200,
};

const qtyLimit = document.querySelector("#quantity-limit").value;
const modal = {
  modal_component: {
    modal: document.createElement("div"),
    alertModal: document.createElement("div"),
    modalHeader: document.createElement("div"),
    modalBody: document.createElement("div"),
    modalFooter: document.createElement("div"),
    modalTitle: document.createElement("h1"),
    modalMsg: document.createElement("p"),
    modalBtn: document.createElement("button"),
  },
  renderModal: function () {
    this.modal_component.modal.setAttribute("id", "modal");
    this.modal_component.alertModal.setAttribute("class", "alert-modal");
    this.modal_component.modalHeader.setAttribute("class", "modal-header");
    this.modal_component.modalBody.setAttribute("class", "modal-body");
    this.modal_component.modalFooter.setAttribute("class", "modal-footer");
    this.modal_component.modalTitle.setAttribute("id", "modal-title");
    this.modal_component.modalMsg.setAttribute("id", "alert-message");
    this.modal_component.modalBtn.setAttribute("class", "alert-btn");
    this.modal_component.modalBtn.innerHTML = "Okay";

    this.modal_component.modalHeader.appendChild(
      this.modal_component.modalTitle
    );
    this.modal_component.modalBody.appendChild(this.modal_component.modalMsg);
    this.modal_component.modalFooter.appendChild(this.modal_component.modalBtn);
    this.modal_component.alertModal.appendChild(
      this.modal_component.modalHeader
    );
    this.modal_component.alertModal.appendChild(this.modal_component.modalBody);
    this.modal_component.alertModal.appendChild(
      this.modal_component.modalFooter
    );
    this.modal_component.modal.appendChild(this.modal_component.alertModal);
    document.body.appendChild(this.modal_component.modal);
    document.querySelector(".alert-btn").addEventListener("click", this.close);
  },

  close: function () {
    let mld = document.querySelector("#modal");
    let mldHeader = document.querySelector(".modal-header");
    mld.style.display = "none";
    location.reload();
  },

  show: function (modalType, modalTitle, modalMsg) {
    let mld = document.querySelector("#modal");
    let mldHeader = document.querySelector(".modal-header");
    let mdltitle = document.querySelector("#modal-title");
    let mdlMsg = document.querySelector("#alert-message");

    mld.style.display = "grid";

    if (modalType == "Error") {
      mldHeader.style.backgroundColor = "red";
    } else if (modalType == "Success") {
      mldHeader.style.backgroundColor = "#008a2a";
    }

    mdltitle.innerHTML = modalTitle;
    mdlMsg.innerHTML = modalMsg;
  },

  modalType: {
    Error: "Error",
    Success: "Success",
  },
};

let productJSON,
  variantQty,
  product_variants,
  availabilityVal = {},
  orderdQty = 1;
var productOrder = {
  id: "",
  qty: 1,
};

const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2, // Ensures two decimal places even for whole numbers
});

const productComponent = {
  size: document.querySelector("#product-size"),
  package: document.querySelector("#product-package"),
  // packageType: document.querySelector("#product-package")
};

const summaryComponent = {
  size: document.querySelector("#product-size>span"),
  qty: document.querySelector("#product-quantity>span"),
  price: document.querySelector("#product-price>span"),
  total: document.querySelector("#product-total-ammount>span"),
};

window.onload = async () => {
  // productJSON = await getProduct(document.querySelector('#productID').value);
  productJSON = await getProduct(document.title.split(" – ")[0]);

  // console.log(JSON.stringify(productJSON));
  console.log(productJSON);
  product_variants = productJSON.options[0].values;

  variantQty = productJSON.variants;
  variantQty.every(aval=>{
    availabilityVal[aval.id] = aval.available;
    return true;
  })

  console.log(availabilityVal);
  initializeSize(product_variants);

  const packageType = document.querySelector("#product-package");
  const packageProperty = packageType.options[packageType.selectedIndex].innerHTML;
  productOrder.qty = parseInt(packages[packageProperty]);
  console.log(productOrder)
  
    modal.renderModal();
  console.log(packages);
};

async function getProduct(productId) {
  let product = await fetch(`/products.json`)
    .then((Response) => Response.json())
    .then((product) => {
      let resultJSON;
      product.products.every((item) => {
        // if (item.id == productId) {
        // alert(`${item.title} - ${productId}`)
        if (item.title == productId) {
          resultJSON = item;
          return false;
        }
        return true;
      });
      return resultJSON;
    });
  return product;
}

function initializeSize(variants) {
  console.log(variants);
  console.log(productJSON.variants);

  productComponent.size.innerHTML = "";
  variants.every((sizes) => {
    const opt = document.createElement("option");
    opt.setAttribute("value", sizes);
    opt.innerHTML = sizes;
    productComponent.size.appendChild(opt);
    console.log(sizes);
    productComponent.selectedIndex = 0;
    return true;
  });
  initializePackage(variants);
}

function initializePackage(variant) {
  console.log(`varianst = ${variant}`);
  console.log(productComponent.package.innerHTML);
  productComponent.package.innerHTML = "";
  let i = 0;

  productJSON.variants.every((product) => {
    if (product.option1 == variant[0]) {
      if (i == 0) {
        console.log(`SELECTED = ${product.id}`)
        productOrder.id = product.id;
        i++;
      }
      const opt = document.createElement("option");
      opt.setAttribute("value", product.id);
      if (!availabilityVal[product.id]){
        opt.disabled = true;
        opt.innerHTML = `${product.option2} - Sold Out`;
      } else {
         opt.innerHTML = product.option2;
      }
      productComponent.package.appendChild(opt);
    }
    return true;
  });
  
  const packageType = document.querySelector("#product-package");
  const packageProperty = packageType.options[packageType.selectedIndex].innerHTML;
  console.log(`Package = ${packages[packageProperty]}`)
  document.querySelector("#quantityValue").value = packages[packageProperty];
  
  console.log(productOrder.id);
  orderSummary(productOrder.id);
}

function orderSummary(varID) {
  var summary = {
    size: "",
    qty: 0,
    price: 0,
    package: "",
  };

  let variantOrder;
  productJSON.variants.every((product) => {
    if (product.id == varID) {
      variantOrder = product;
      return false;
    } else {
      return true;
    }
  });

  console.log(variantOrder);

  summary.size = variantOrder.option1;
  summary.qty = productOrder.qty;
  summary.price = variantOrder.price;
  summary.package = variantOrder.option2;

  console.log(
    `${productJSON.title} | ${productComponent.size.value} | ${productComponent.package.value} | ${productOrder.qty}`
  );

  let total_Qty = summary.qty * pType[summary.package];

  summaryComponent.size.innerHTML = summary.size;
  // summaryComponent.qty.innerHTML = `<strong>${summary.qty}</strong> <span class="smallcaps">BOX</span> | <strong>${total_Qty}</strong> <span class="smallcaps">PIECES</span>`;
  summaryComponent.qty.innerHTML = `<strong>${total_Qty}</strong> <span class="smallcaps">PIECES</span>`;
  summaryComponent.price.innerHTML = `$${summary.price}`;
  summaryComponent.total.innerHTML = formatter.format(
    summary.price * summary.qty
  );
}

/*==============================================================================================
====================================SELECTION FUNCTIONS=========================================
==============================================================================================*/

document.querySelector("#product-size").addEventListener("change", (e) => {
  console.log(e.target.value);
  productComponent.package.innerHTML = "";
  let i = 0;
  productJSON.variants.every((product) => {
    if (product.option1 === e.target.value) {
      if (i == 0) {
        productOrder.id = product.id;
        i++;
      }
      const opt = document.createElement("option");
      opt.setAttribute("value", product.id);
      opt.setAttribute("id", product.option2);
      if (!availabilityVal[product.id]){
        opt.disabled = true;
        opt.innerHTML = `${product.option2} - Sold Out`;
      } else {
         opt.innerHTML = product.option2;
      }
      productComponent.package.appendChild(opt);
    }
    return true;
  });
  orderSummary(productOrder.id);
});

productComponent.package.addEventListener("change", (e) => {
  const packageType = document.querySelector("#product-package");
  const packageProperty = packageType.options[packageType.selectedIndex].innerHTML;
  console.log(`Package = ${packages[packageProperty]}`)
  document.querySelector("#quantityValue").value = packages[packageProperty];
  productOrder.id = e.target.value;
  orderSummary(productOrder.id);
});

/*==============================================================================================
======================================BUTTON FUNCTIONS==========================================
==============================================================================================*/

document.querySelector("#addtocart").addEventListener("click", async function () {
    let stat = await fetch("/cart/add.js", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        id: productOrder.id,
        quantity: productOrder.qty,
      }),
    });
    if (stat) {
      modal.show(
        modal.modalType.Success,
        "Successful",
        "Item successfully added to cart"
      );
    }
  });

document.querySelector("#cart_button").addEventListener("click", (e) => {
  show_cart();
});

function show_cart() {
  const mdl = document.querySelector(".cart-modal");
  cart_item();
  mdl.style.display = "grid";
}

function cart_item() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      const cartSummary = {
        item_total_qty: document.querySelector("#cart_qty"),
        cart_sub_total: document.querySelector("#sub_total"),
      };

      cartSummary.item_total_qty.innerHTML = Intl.NumberFormat().format(
        cart.item_count
      );
      cartSummary.cart_sub_total.innerHTML = `$${Intl.NumberFormat().format(
        (cart.items_subtotal_price / 100).toFixed(2)
      )}`;

      const cart_rack = document.querySelector("#cart-rack");
      cart_rack.innerHTML = "";

      console.log(JSON.stringify(cart));
      cart.items.every((itm) => {
        const cartItem = {
          cartItem: document.createElement("div"),
          itemGrid: document.createElement("div"),

          itemImgDiv: document.createElement("div"),

          itemImage: document.createElement("img"),

          itemDetailsDiv: document.createElement("div"),

          itemHeader: document.createElement("h1"),
          itemDetails: document.createElement("p"),

          qtyGrid: document.createElement("div"),
          itemQtyDiv: document.createElement("div"),
          qtyLbl: document.createElement("label"),

          qtyComp: document.createElement("div"),
          addBtn: document.createElement("button"),
          subBtn: document.createElement("button"),
          itemQty: document.createElement("input"),

          itemPriceDiv: document.createElement("div"),
          itemPrice: document.createElement("p"),

          itemRemove: document.createElement("p"),
          presentment: document.createElement("p"),
        };

        let unfrmtPrice = itm.final_price / 100;
        let frmtdPrice = unfrmtPrice.toFixed(2);
        let item_price = (
          (itm.final_price / 100).toFixed(2) * itm.quantity
        ).toFixed(2);
        //   alert(`$${Intl.NumberFormat().format((itm.final_price / 100).toFixed(2))}`);

        cartItem.cartItem.setAttribute("class", "tmp-cart-item");
        cartItem.itemGrid.setAttribute("class", "cart-item-grid");
        cartItem.itemImgDiv.setAttribute("class", "cart-item-img");
        cartItem.itemImage.setAttribute("class", "cart-item-img");
        cartItem.itemQtyDiv.setAttribute("class", "cart-item-qty");
        cartItem.itemImage.setAttribute("src", itm.featured_image.url);
        cartItem.itemDetailsDiv.setAttribute("class", "cart-item-details");
        cartItem.itemHeader.setAttribute("id", "cart-item-h1");

        const headerString = itm.title.split(" - ");

        
        cartItem.itemHeader.innerHTML = `${headerString[0]} - ${headerString[1]}`
        cartItem.itemDetails.setAttribute("class", "order-details");
        cartItem.itemDetails.innerHTML = `${itm.variant_options[0]} | ${itm.variant_options[1]}`;
        cartItem.itemQtyDiv.setAttribute("class", "cart-item-qty");
        cartItem.qtyGrid.setAttribute("class", "cart-qty-grid");
        cartItem.qtyLbl.innerHTML = "Qty.";
        cartItem.qtyComp.setAttribute("class", "qty-component");
        cartItem.qtyComp.setAttribute("id", itm.id);
        cartItem.addBtn.setAttribute("id", "qty-add");
        cartItem.addBtn.setAttribute("product-data", itm.variant_options[1]);
        cartItem.addBtn.innerHTML = "+";
        cartItem.subBtn.setAttribute("id", "qty-sub");
        cartItem.subBtn.setAttribute("product-data", itm.variant_options[1]);
        cartItem.subBtn.innerHTML = "-";
        cartItem.itemQty.setAttribute("type", "number");
        cartItem.itemQty.setAttribute("value", itm.quantity);
        cartItem.itemQty.setAttribute("id", "item-qty");
        cartItem.itemPriceDiv.setAttribute("class", "item-total-price");
        cartItem.itemPrice.setAttribute("class", "price");
        cartItem.itemPrice.innerHTML = `total: $${Intl.NumberFormat().format(
          item_price
        )}`;
        cartItem.itemRemove.setAttribute("class", "remove-item-btn");
        cartItem.itemRemove.innerHTML = "Remove";
        cartItem.itemRemove.setAttribute("id", itm.id);
        cartItem.presentment.setAttribute("id", "pPrice");
        cartItem.presentment.innerHTML = itm.presentment_price;

        cartItem.qtyComp.appendChild(cartItem.subBtn);
        cartItem.qtyComp.appendChild(cartItem.itemQty);
        cartItem.qtyComp.appendChild(cartItem.addBtn);

        cartItem.itemQtyDiv.appendChild(cartItem.qtyLbl);
        cartItem.itemQtyDiv.appendChild(cartItem.qtyComp);

        cartItem.itemPriceDiv.appendChild(cartItem.presentment);
        cartItem.itemPriceDiv.appendChild(cartItem.itemPrice);

        cartItem.qtyGrid.appendChild(cartItem.itemQtyDiv);
        cartItem.qtyGrid.appendChild(cartItem.itemPriceDiv);

        cartItem.itemDetailsDiv.appendChild(cartItem.itemHeader);
        cartItem.itemDetailsDiv.appendChild(cartItem.itemDetails);

        cartItem.itemDetailsDiv.appendChild(cartItem.qtyGrid);
        cartItem.itemDetailsDiv.appendChild(cartItem.itemRemove);

        cartItem.itemImgDiv.appendChild(cartItem.itemImage);

        cartItem.itemGrid.appendChild(cartItem.itemImgDiv);
        cartItem.itemGrid.appendChild(cartItem.itemDetailsDiv);

        cartItem.cartItem.appendChild(cartItem.itemGrid);

        cart_rack.appendChild(cartItem.cartItem);

        return true;
      });
    });
}

document.querySelector("#cart-rack").addEventListener("click", async function (e) {
  const item_qty = e.target.parentNode.querySelector("#item-qty");
  let newVal = item_qty.value;

  console.log(`Button click = ${e.target.getAttribute("product-data")}`);
  
  if (e.target.nodeName == "BUTTON") {
    const total_price = e.target.parentNode.parentNode.parentNode
      .querySelector(".item-total-price")
      .querySelector(".price");
    const pPrice = e.target.parentNode.parentNode.parentNode
      .querySelector(".item-total-price")
      .querySelector("#pPrice");

    if (e.target.id == "qty-add") {
      newVal = parseInt(newVal) + packages[e.target.getAttribute("product-data")];
    } else if (e.target.id == "qty-sub") {
      newVal -= packages[e.target.getAttribute("product-data")];
    }

    updateCart(e.target.parentNode.id, newVal);

    item_qty.value = newVal;
    total_price.innerHTML = `total: $${pPrice.innerHTML * newVal}`;
  } else if (e.target.className == "remove-item-btn") {
    updateCart(e.target.id, 0);
  }
});

async function updateCart(itemID, Qty) {
  const loadingScreen = document.querySelector(".loading");

  loadingScreen.style.display = "grid";
  let data = { id: itemID };
  let stat = await fetch("/cart/change.json", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({
      ...data,
      quantity: Qty,
    }),
  });
  if (stat) {
    cart_item();
    loadingScreen.style.display = "none";
  }
}

document.querySelector("#close-cart").addEventListener("click", function () {
  const mdl = document.querySelector(".cart-modal");
  mdl.style.display = "none";
});

document
  .querySelector("#custom_checkout_btn")
  .addEventListener("click", function () {
    window.open("/checkout", "_self", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        id: "",
      }),
    });
  });

document.querySelector("#add").addEventListener("click", (e) => {
  productQty(e);
});
document.querySelector("#sub").addEventListener("click", (e) => {
  productQty(e);
});
document.querySelector("#quantityValue").addEventListener("blur", (e) => {
  validateInputQty();
});
productComponent.package.addEventListener("change", (e) => {
  validateInputQty();
  productOrder.id = e.target.value;
  orderSummary(productOrder.id);
});

function validateInputQty() {
  const packageType = document.querySelector("#product-package");
  const pcs = packageType.options[packageType.selectedIndex].innerHTML;
  const qtyValue = document.getElementById("quantityValue");
  var tempVal = qtyValue.value;
  validateQuantity(parseInt(tempVal), packages[pcs]);
}

function productQty(e) {
  const packageType = document.querySelector("#product-package");
  // const pcs = pType[packageType.options[packageType.selectedIndex].id];
  const packageProperty = packageType.options[packageType.selectedIndex].innerHTML;
  console.log(`Test = ${packageProperty} - ${packages[packageProperty]}`);
  const pcs = pType[packageProperty];
  const qtyValue = document.getElementById("quantityValue");
  const mathOperation = e.target.value;
  var tempVal = qtyValue.value;

  // QUANTITY SCRIPT
  if (mathOperation == "addition") {
    console.log(packageProperty);
    validateQuantity(parseInt(tempVal) + packages[packageProperty], pcs);
  } else if (mathOperation == "minus") {
    validateQuantity(parseInt(tempVal) - packages[packageProperty], pcs);
  }
  orderSummary(productOrder.id);
}

function validateQuantity(qty, pckg) {
  const packageType = document.querySelector("#product-package");
  const packageProperty = packageType.options[packageType.selectedIndex].innerHTML;

  
  // alert(`pkg: ${pckg} qty: ${qty}`)
  const finalQty = document.getElementById("quantityValue");
  var totalQty = pckg * qty;
  console.log(`total qty: ${totalQty} pkg: ${pckg} qty: ${qty}`);

  // alert(valueFormat(qty, pckg));

  if (valueFormat(qty, pckg) == 0){
    if (checkValue(totalQty)) {
      if (checkLimit(totalQty)) {
        finalQty.value = qty;
      } else {
        finalQty.value = qtyLimit / pckg;
        alert(`The maximum order quantity is ${qtyLimit}.`);
      }
      productOrder.qty = finalQty.value;
    } else {
      alert("The order quantity cannot be less than 1.");
      finalQty.value = pckg;
    }
  } else {
    alert(`${packageProperty}: Quantity must be a multiple of ${pckg}`);
    finalQty.value = pckg;
  }
  orderSummary(productOrder.id);
}

function checkLimit(Qty) {
  if (qtyLimit > 0) {
    if (Qty <= qtyLimit) {
      return true;
    } else {
      return false;
    }
  } else {
    return true;
  }
}

function checkValue(val) {
  // alert(val)
  if (val > 0) {
    return true;
  } else {
    return false;
  }
}

function valueFormat(val, pckg) {
  return (val / pckg) % 1;
}

function getPackageCount(pckg) {
  let packageCount = pckg.split(" ")[0];
  return packageCount;
}

function me_close(str_id) {
  const modalToclose = document.querySelector(`.${str_id}-modal`);
  modalToclose.style.display = "none";
}


document.querySelector('.navbar-collapser').addEventListener("click", e=>{
  const navbar = document.querySelector('.navbar');
  navbar.classList.remove('navbar-show');
})

document.querySelector('.navbar-toggler').addEventListener("click", e=>{
  const navbar = document.querySelector('.navbar');
  navbar.classList.add('navbar-show');
})


document.querySelector(".navbar").addEventListener("click", e=>{
    if (e.target.nodeName == "A"){
      const navbar = document.querySelector('.navbar');
      navbar.classList.remove('navbar-show');
    }
})